export default class {

    constructor ($q, $uibModal, $translate, lodash) {
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.lodash = lodash;

        this.defaultPopupOptions = {
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            },
            animation: true,
            backdrop: 'static',
            size: 'medium',
            controllerAs: 'vm'
        };
    }

    delete (confirmMessage) {
        if (confirmMessage === undefined) {
            confirmMessage = this.$translate.instant('general.Confirm deleting entry');
        }
        return this.confirm(confirmMessage);
    }

    confirm (message, size = 'small', strong = false) {
        if (typeof message === 'string') {
            message = [message];
        }

        const deferred = this.$q.defer();
        const recursiveConfirm = (messages, resolve, reject) => {
            if (!messages.length) {
                resolve('Messages confirmed');
                return;
            }
            this.confirmModal(messages.shift(), size, strong)
                .then(() => recursiveConfirm(messages, resolve, reject))
                .catch((action) => {
                    reject(action);
                })
            ;
        };

        recursiveConfirm(message, deferred.resolve, deferred.reject);

        return deferred.promise;
    }

    confirmModal (title, size = 'small', strong = false) {
        const style = "{'background-color':'#ff7f6a','color':'white'}";
        return this.open({
            template: `
                <div class="wrapper">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" ng-click="vm.$uibModalInstance.dismiss('x')"></button>
                            <h2 class="modal-title">{{ 'general.Confirm' | translate }}</h2>
                        </div>
                        <div ng-if="${strong}" class="modal-body" ng-style="${style}">
                            <p>${title}</p>
                        </div>
                        <div ng-if="${strong !== true}" class="modal-body">
                            <p>${title}</p>
                        </div>
                        <div class="modal-footer">
                            <ul class="actions01">
                                <li class="primary">
                                    <button class="btn main" type="button"  ng-click="vm.$uibModalInstance.close()">{{ 'general.Yes' | translate }}</button>
                                </li>
                                <li>
                                    <button class="btn discrete" autofocus type="button" ng-click="vm.$uibModalInstance.dismiss('no')">{{ 'general.No' | translate }}</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            `,
            size
        });
    }

    open (options) {
        return this.$uibModal.open(this.lodash.extend({}, this.defaultPopupOptions, options)).result;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/modal/index.js